import { render, staticRenderFns } from "./main.vue?vue&type=template&id=c5b136ce&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=c5b136ce&prod&scoped=true&lang=css"
import style1 from "./main.vue?vue&type=style&index=1&id=c5b136ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b136ce",
  null
  
)

export default component.exports